/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedMeasurementUnitProvider_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespAppliedFilters_user$ref: FragmentReference;
export type SbRespAppliedFilters_user = {|
  +$fragmentRefs: SbSharedMeasurementUnitProvider_user$ref,
  +$refType: SbRespAppliedFilters_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespAppliedFilters_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedMeasurementUnitProvider_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1bfb05c02214c19d1643769e11afc5fe';
module.exports = node;
